export const LOGIN_SUCCEEDED = "auth/LOGIN_SUCCEEDED";
export const RESET = "auth/RESET";
